<app-header></app-header>
<app-leftsidebar></app-leftsidebar>

<main class="store-stub">
  <div class="store-stub-wrap">
    @if (vendorHeader) {
      <nav class="shop-crumbs" aria-label="Breadcrumb">
        <a routerLink="/marketplace/all-shops">All shops</a>
        <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6" /></svg>
        <span aria-current="page">{{ vendorHeader.shop_name }}</span>
      </nav>
      <section class="shop-hero">
        <span class="shop-hero-banner" [style.background-image]="vendorHeader.banner ? 'url(' + vendorHeader.banner + ')' : null"></span>
        <div class="shop-hero-body">
          @if (vendorHeader.logo) {
            <img class="shop-hero-logo" [src]="vendorHeader.logo" alt="" />
          } @else {
            <span class="shop-hero-logo shop-hero-logo--letter" aria-hidden="true">{{ vendorHeader.shop_name.charAt(0).toUpperCase() }}</span>
          }
          <div class="shop-hero-info">
            <h1>{{ vendorHeader.shop_name }}</h1>
            <div class="shop-hero-stats">
              <span><strong>{{ vendorHeader.listing_count ?? 0 }}</strong> item{{ vendorHeader.listing_count === 1 ? '' : 's' }}</span>
              <span><strong>{{ vendorHeader.follower_count ?? 0 }}</strong> follower{{ vendorHeader.follower_count === 1 ? '' : 's' }}</span>
              @if (vendorHeader.rating_count > 0) {
                <span class="shop-hero-rating">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
                  <strong>{{ vendorHeader.rating_avg | number: '1.1-1' }}</strong> ({{ vendorHeader.rating_count }})
                </span>
              }
              <span class="shop-hero-since">Since {{ vendorHeader.created_at | date: 'MMM y' }}</span>
            </div>
            @if (vendorHeader.bio) {
              <p class="shop-hero-bio">{{ vendorHeader.bio }}</p>
            }
          </div>
          <div class="shop-hero-actions">
            @if (vendorHeader.is_mine) {
              <a class="shop-hero-btn" routerLink="/marketplace/vendor-dashboard" fragment="shop-profile">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
                Edit shop
              </a>
            } @else {
              <button
                type="button"
                class="shop-hero-btn"
                [class.is-on]="vendorHeader.follow_id"
                [disabled]="followBusy"
                (click)="toggleShopFollow()"
              >
                @if (vendorHeader.follow_id) {
                  <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  Following
                } @else {
                  <svg viewBox="0 0 24 24" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  Follow
                }
              </button>
            }
          </div>
        </div>
      </section>
    }

    <!-- Title row: heading + search -->
    <div class="store-head">
      <div class="store-head-title" *ngIf="!vendorHeader">
        <h1>{{ storeHeading() }}</h1>
        <p class="store-stub-lede">Digital maps, modules and campaigns from every WorldTumbler vendor.</p>
      </div>
      <div class="store-head-actions">
        <label class="store-search">
          <svg class="store-search-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
          <input
            type="search"
            placeholder="Search the store…"
            [value]="searchText"
            (input)="onSearchInput($any($event.target).value)"
            aria-label="Search the store"
          />
        </label>
        <a class="store-favorites-link" routerLink="/marketplace/all-shops">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9l1.5-5h15L21 9" /><path d="M4 9v11h16V9" /><path d="M9 20v-6h6v6" /></svg>
          All shops
        </a>
        <a class="store-favorites-link" routerLink="/marketplace/favorites">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
          My favorites
        </a>
      </div>
    </div>

    <!-- Category tabs -->
    @if (typeTabs.length) {
      <nav class="store-tabs" aria-label="Content type">
        <button type="button" class="store-tab" [class.is-active]="!activeType && !selectedCount('type')" (click)="selectType(null)">All</button>
        @for (type of typeTabs; track type) {
          <button type="button" class="store-tab" [class.is-active]="activeType === type" (click)="selectType(type)">{{ type }}</button>
        }
      </nav>
    }

    <!-- Filter bar: dropdown pills + All filters + Sort -->
    <div class="store-filterbar">
      <div class="store-pills">
        @for (pill of [{ key: 'genre', label: 'Genre' }, { key: 'system', label: 'System' }]; track pill.key) {
          @if (optionsFor(pill.key).length) {
            <div class="store-pill-wrap">
              <button
                type="button"
                class="store-pill"
                [class.is-active]="selectedCount(pill.key) > 0"
                [class.is-open]="openMenu === pill.key"
                (click)="toggleMenu(pill.key, $event)"
                [attr.aria-expanded]="openMenu === pill.key"
              >
                {{ pill.label }}@if (selectedCount(pill.key)) { · {{ selectedCount(pill.key) }} }
                <svg class="store-pill-caret" viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
              </button>
              @if (openMenu === pill.key) {
                <div class="store-menu" (click)="keepMenuOpen($event)">
                  @for (option of optionsFor(pill.key); track option.value) {
                    <label class="store-menu-check">
                      <input
                        type="checkbox"
                        [checked]="isChecked(pill.key, option.value)"
                        (change)="toggleValue(pill.key, option.value, $any($event.target).checked)"
                      />
                      <span>{{ option.value }}</span>
                      @if (option.count) { <span class="store-menu-count">{{ option.count }}</span> }
                    </label>
                  }
                </div>
              }
            </div>
          }
        }

        <div class="store-pill-wrap">
          <button
            type="button"
            class="store-pill"
            [class.is-active]="query['free'] === '1' || !!query['price_max']"
            [class.is-open]="openMenu === 'price'"
            (click)="toggleMenu('price', $event)"
            [attr.aria-expanded]="openMenu === 'price'"
          >
            {{ priceLabel }} <svg class="store-pill-caret" viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
          </button>
          @if (openMenu === 'price') {
            <div class="store-menu store-menu--price" (click)="keepMenuOpen($event)">
              <div class="store-menu-presets">
                <button type="button" class="store-chip-btn" [class.is-active]="pricePreset === 'any'" (click)="setPricePreset('any')">Any</button>
                <button type="button" class="store-chip-btn" [class.is-active]="pricePreset === 'free'" (click)="setPricePreset('free')">Free</button>
                @for (amount of pricePresets; track amount) {
                  <button
                    type="button"
                    class="store-chip-btn"
                    [class.is-active]="pricePreset === '' + amount"
                    (click)="setPricePreset(amount)"
                  >Under ${{ amount }}</button>
                }
              </div>
              <label class="store-menu-field">
                <span>Custom max price</span>
                <span class="store-money">
                  <span aria-hidden="true">$</span>
                  <input type="number" min="0" step="1" placeholder="—" [value]="query['price_max'] || ''" (change)="setMaxPrice($any($event.target).value)" />
                </span>
              </label>
            </div>
          }
        </div>

        <div class="store-pill-wrap">
          <button
            type="button"
            class="store-pill"
            [class.is-active]="!!query['min_rating']"
            [class.is-open]="openMenu === 'rating'"
            (click)="toggleMenu('rating', $event)"
            [attr.aria-expanded]="openMenu === 'rating'"
          >
            {{ ratingLabel }} <svg class="store-pill-caret" viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
          </button>
          @if (openMenu === 'rating') {
            <div class="store-menu" (click)="keepMenuOpen($event)">
              @for (option of ratingOptions; track option.value) {
                <label class="store-menu-check">
                  <input
                    type="radio"
                    name="store-rating"
                    [checked]="(query['min_rating'] || '') === option.value"
                    (change)="setSingle('min_rating', option.value); openMenu = null"
                  />
                  <span>{{ option.label }}</span>
                </label>
              }
            </div>
          }
        </div>

        <button type="button" class="store-pill store-pill--all" (click)="openDrawer()">
          <svg class="store-pill-icon" viewBox="0 0 24 24" aria-hidden="true"><line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" /><line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" /><line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" /><line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" /></svg> All filters @if (activeCount) { <span class="store-pill-badge">{{ activeCount }}</span> }
        </button>
      </div>

      <div class="store-pill-wrap store-sort-wrap">
        <button
          type="button"
          class="store-pill store-pill--sort"
          [class.is-open]="openMenu === 'sort'"
          (click)="toggleMenu('sort', $event)"
          [attr.aria-expanded]="openMenu === 'sort'"
        >
          Sort: {{ sortLabel }} <svg class="store-pill-caret" viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
        </button>
        @if (openMenu === 'sort') {
          <div class="store-menu store-menu--right" (click)="keepMenuOpen($event)">
            @for (option of sortOptions; track option.value) {
              <button
                type="button"
                class="store-menu-option"
                [class.is-active]="sortValue === option.value"
                (click)="setSingle('sort', option.value); openMenu = null"
              >{{ option.label }}</button>
            }
          </div>
        }
      </div>
    </div>

    <!-- Active filters -->
    @if (activeChips.length) {
      <div class="store-active">
        <ul class="store-active-chips">
          @for (chip of activeChips; track chip.key + (chip.value || '')) {
            <li>
              <button type="button" (click)="removeChip(chip)" [attr.aria-label]="'Remove filter ' + chip.label">
                {{ chip.label }} <span aria-hidden="true">×</span>
              </button>
            </li>
          }
        </ul>
        <button type="button" class="store-text-btn" (click)="clearAll()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>
          Clear all
        </button>
      </div>
    }

    @if (loading) {
      <!-- First load: placeholder cards in the shape of the real ones. -->
      <div class="store-count-row">
        <span class="store-skel store-skel--count"></span>
      </div>
      <div class="store-grid" aria-busy="true" aria-label="Loading results">
        @for (i of skeletonCards; track i) {
          <div class="store-card store-card--skeleton">
            <span class="store-skel store-skel--cover"></span>
            <span class="store-card-body">
              <span class="store-skel store-skel--title"></span>
              <span class="store-skel store-skel--line"></span>
              <span class="store-skel store-skel--line is-short"></span>
            </span>
            <span class="store-card-action"><span class="store-skel store-skel--btn"></span></span>
          </div>
        }
      </div>
    } @else {
      <div class="store-count-row">
        <p class="store-stub-count">{{ totalCount }} result{{ totalCount === 1 ? '' : 's' }}</p>
        @if (refreshing) {
          <span class="store-spinner" role="status" aria-label="Updating results"></span>
        }
      </div>

      @if (!items.length) {
        <div class="store-empty">
          <span class="store-empty-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /><line x1="8" y1="11" x2="14" y2="11" /></svg>
          </span>
          @if (activeCount) {
            <h3>No results found</h3>
            <p>Try removing a filter, or search for something else.</p>
            <button type="button" class="wt-btn-primary store-empty-btn" (click)="clearAll()">
              <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>
              Clear all filters
            </button>
          } @else {
            <h3>Nothing in the store yet</h3>
            <p>New maps, modules and campaigns will show up here as creators publish them.</p>
          }
        </div>
      }

      <div class="store-grid" [class.is-refreshing]="refreshing" [attr.aria-busy]="refreshing">
        <article
          class="store-card"
          *ngFor="let item of items"
          [class.is-highlight]="item.id === highlightId"
        >
          <a class="store-card-link" [routerLink]="['/marketplace/listing', item.id]">
            <span class="store-card-cover" [style.background-image]="'url(' + item.image + ')'">
              <span class="store-card-type">{{ item.type }}</span>
              <span class="store-card-price" [class.is-free]="!item.price">{{ item.price ? '$' + item.price : 'Free' }}</span>
            </span>
            <span class="store-card-body">
              <h2>{{ item.title }}</h2>
              <span class="store-card-shop">{{ item.author }}</span>
              @if (item.gamesystem || item.party) {
                <span class="store-card-meta">
                  {{ item.gamesystem }}@if (item.gamesystem && item.party) { · }{{ item.party }}
                </span>
              }
              <span class="store-card-rating">
                @if (item.reviews) {
                  ★ {{ item.rating | number: '1.1-1' }} <span class="store-card-reviews">({{ item.reviews }})</span>
                } @else {
                  <span class="store-card-reviews">No reviews yet</span>
                }
              </span>
            </span>
          </a>
          <button
            type="button"
            class="store-card-fav"
            [class.is-favorited]="isFavorited(item)"
            (click)="toggleFavorite(item, $event)"
            [attr.aria-label]="isFavorited(item) ? 'Remove from favorites' : 'Add to favorites'"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
          </button>
          <div class="store-card-action">
            @if (item.isMine) {
              <span class="store-card-state">Your item</span>
            } @else if (item.isOwned) {
              <a class="store-card-state is-owned" routerLink="/marketplace/orders">Owned — view</a>
            } @else if (item.price === 0) {
              <button type="button" class="store-card-btn" [disabled]="addingToCartId === item.id" (click)="claimFree(item, $event)">
                {{ addingToCartId === item.id ? 'Getting…' : 'Get for free' }}
              </button>
            } @else {
              <button type="button" class="store-card-btn" [disabled]="addingToCartId === item.id" (click)="addToCart(item, $event)">
                {{ addingToCartId === item.id ? 'Adding…' : 'Add to cart' }}
              </button>
            }
          </div>
        </article>
      </div>

      @if (hasNextPage) {
        <div class="store-stub-more">
          <button type="button" class="store-stub-more-btn" [disabled]="loadingMore" (click)="loadMore()">
            {{ loadingMore ? 'Loading…' : 'Load more' }}
          </button>
        </div>
      }
    }
  </div>
</main>

<!-- "All filters" drawer -->
<ng-template #sectionIcon let-name>
  <svg class="sf-icon" viewBox="0 0 24 24" aria-hidden="true">
    @switch (name) {
      @case ('price') { <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><circle cx="7" cy="7" r="1.5" /> }
      @case ('star') { <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /> }
      @case ('users') { <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /> }
      @case ('game') { <rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="8.5" cy="8.5" r="1.2" /><circle cx="12" cy="12" r="1.2" /><circle cx="15.5" cy="15.5" r="1.2" /> }
      @case ('layers') { <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /> }
      @case ('map') { <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" /><line x1="8" y1="2" x2="8" y2="18" /><line x1="16" y1="6" x2="16" y2="22" /> }
    }
  </svg>
</ng-template>

@if (drawerOpen) {
  <div class="sf-backdrop" (click)="closeDrawer()"></div>
  <aside class="sf-drawer" role="dialog" aria-modal="true" aria-label="All filters">
    <header class="sf-head">
      <div>
        <h2>Filters</h2>
        <p>
          @if (loading) { Updating&hellip; } @else { Showing {{ totalCount }} result{{ totalCount === 1 ? '' : 's' }} }
        </p>
      </div>
      <button type="button" class="sf-close" (click)="closeDrawer()" aria-label="Close filters">
        <svg viewBox="0 0 24 24" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" /></svg>
      </button>
    </header>

    <div class="sf-body">
      <!-- Price -->
      <section class="sf-section is-open">
        <div class="sf-section-head">
          <ng-container *ngTemplateOutlet="sectionIcon; context: { $implicit: 'price' }"></ng-container>
          <span>Price</span>
        </div>
        <div class="sf-segmented" role="group" aria-label="Price">
          <button type="button" [class.is-active]="pricePreset === 'any'" (click)="setPricePreset('any')">Any</button>
          <button type="button" [class.is-active]="pricePreset === 'free'" (click)="setPricePreset('free')">Free</button>
          @for (amount of pricePresets; track amount) {
            <button type="button" [class.is-active]="pricePreset === '' + amount" (click)="setPricePreset(amount)">&lt; ${{ amount }}</button>
          }
        </div>
        <label class="sf-inline-field">
          <span>Custom max</span>
          <span class="sf-money">
            <span aria-hidden="true">$</span>
            <input type="number" min="0" step="1" placeholder="—" [value]="query['price_max'] || ''" (change)="setMaxPrice($any($event.target).value)" />
          </span>
        </label>
      </section>

      <!-- Rating -->
      <section class="sf-section is-open">
        <div class="sf-section-head">
          <ng-container *ngTemplateOutlet="sectionIcon; context: { $implicit: 'star' }"></ng-container>
          <span>Rating</span>
        </div>
        <div class="sf-segmented" role="group" aria-label="Minimum rating">
          <button type="button" [class.is-active]="!query['min_rating']" (click)="setSingle('min_rating', null)">Any</button>
          @for (stars of ['4', '3', '2']; track stars) {
            <button type="button" [class.is-active]="query['min_rating'] === stars" (click)="setSingle('min_rating', stars)">★ {{ stars }}+</button>
          }
        </div>
      </section>

      <!-- Party & playtime -->
      <section class="sf-section is-open">
        <div class="sf-section-head">
          <ng-container *ngTemplateOutlet="sectionIcon; context: { $implicit: 'users' }"></ng-container>
          <span>Party &amp; playtime</span>
        </div>
        <div class="sf-stepper-row">
          <span class="sf-stepper-label">Players</span>
          <div class="sf-stepper">
            <button type="button" (click)="stepNumber('players', -1)" [disabled]="!query['players']" aria-label="Fewer players">−</button>
            <span>{{ query['players'] || 'Any' }}</span>
            <button type="button" (click)="stepNumber('players', 1)" aria-label="More players">+</button>
          </div>
        </div>
        <div class="sf-stepper-row">
          <span class="sf-stepper-label">Max playtime</span>
          <div class="sf-stepper">
            <button type="button" (click)="stepNumber('playtime_max', -1)" [disabled]="!query['playtime_max']" aria-label="Less playtime">−</button>
            <span>{{ query['playtime_max'] ? query['playtime_max'] + ' h' : 'Any' }}</span>
            <button type="button" (click)="stepNumber('playtime_max', 1)" aria-label="More playtime">+</button>
          </div>
        </div>
      </section>

      <!-- Game / Play details / Terrain & setting -->
      @for (section of drawerSections; track section.id) {
        <section class="sf-section sf-collapsible" [class.is-open]="isSectionOpen(section.id, section.activeCount)">
          <button
            type="button"
            class="sf-section-head sf-section-toggle"
            (click)="toggleSection(section.id, section.activeCount)"
            [attr.aria-expanded]="isSectionOpen(section.id, section.activeCount)"
          >
            <ng-container *ngTemplateOutlet="sectionIcon; context: { $implicit: section.icon }"></ng-container>
            <span>{{ section.label }}</span>
            @if (section.activeCount) { <span class="sf-badge">{{ section.activeCount }}</span> }
            <svg class="sf-chevron" viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9" /></svg>
          </button>

          @if (isSectionOpen(section.id, section.activeCount)) {
            <div class="sf-section-body">
              @for (group of section.groups; track group.key) {
                <div class="sf-group">
                  <h4>{{ group.label }}</h4>
                  <div class="sf-chips">
                    @for (option of group.options; track option.value) {
                      <button
                        type="button"
                        class="sf-chip"
                        [class.is-active]="isChecked(group.key, option.value)"
                        [attr.aria-pressed]="isChecked(group.key, option.value)"
                        (click)="toggleValue(group.key, option.value, !isChecked(group.key, option.value))"
                      >
                        {{ option.value }}
                        @if (option.count) { <span class="sf-chip-count">{{ option.count }}</span> }
                      </button>
                    }
                  </div>
                  @if (group.hiddenCount > 0 || expandedGroups.has(group.key)) {
                    <button type="button" class="sf-more" (click)="toggleGroup(group.key)">
                      {{ expandedGroups.has(group.key) ? 'Show less' : 'Show all ' + (group.options.length + group.hiddenCount) }}
                    </button>
                  }
                </div>
              }
            </div>
          }
        </section>
      }
    </div>

    <footer class="sf-foot">
      <button type="button" class="sf-clear" [disabled]="!activeCount" (click)="clearAll()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>
        Clear all
      </button>
      <button type="button" class="sf-apply" (click)="closeDrawer()">
        Show {{ totalCount }} result{{ totalCount === 1 ? '' : 's' }}
      </button>
    </footer>
  </aside>
}

<app-footer></app-footer>
